module.exports = __webpack_public_path__ + "img/img10.c0f1403e.svg";